import { render, staticRenderFns } from "./driverFraction.vue?vue&type=template&id=da53488c&scoped=true&"
import script from "./driverFraction.vue?vue&type=script&lang=js&"
export * from "./driverFraction.vue?vue&type=script&lang=js&"
import style0 from "./driverFraction.vue?vue&type=style&index=0&id=da53488c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da53488c",
  null
  
)

export default component.exports